import { DialogActions } from "@material-ui/core";
import { useFormikContext } from "formik";
import { Editor } from "primereact/editor";
import { TabPanel, TabView } from "primereact/tabview";
import React, { useState } from "react";
import DialogLayout from "../../../../partials/content/DialogLayout";
import {
  FormDateField,
  FormTextField,
} from "../../../../partials/content/Forms/FormField";
import { Card, Badge } from "react-bootstrap";
import { getPurchaseOrderItems } from "../../../../services/inventory/procurementService";
import {
  getVendorAddress,
  getVendorContact,
} from "../../../../services/inventory/vendorService";
import SearchVendor from "../../inventory/vendors/searchVendor";
import SearchCurrency from "../../setup/finance/searchCurrency";
import IncomingInvoiceAddress from "./incomingInvoiceAddress";
import IncomingInvoiceContact from "./incomingInvoiceContact";
import SearchIncomingInvoiceDocRef from "./searcIncomingInvoiceDocRef";
import { amountByPercent } from "../../../../utils/utils";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
import { DateTime } from "luxon";
import SearchVendorBankAccount from "../../inventory/vendors/vendorDetail/SearchVendorBankAccount";

function IncomingInvoiceHeader(props) {
  const { companyProfile } = useGlobalData();
  const { setFieldValue, values } = useFormikContext();
  const [openSearchDocRef, setOpenSearchDocRef] = useState(false);
  const [openSearchCurrency, setOpenSearchCurrency] = useState(false);
  const [openSearchVendor, setOpenSearchVendor] = useState(false);
  const [vendorAddresses, setVendorAddresses] = useState([]);
  const [vendorContacts, setVendorContacts] = useState([]);
  const [vendorAddressDefault, setVendorAddressDefault] = useState(false);
  const [vendorContactDefault, setVendorContactDefault] = useState(false);
  const [openSearchBankVendor, setOpenSearchBankVendor] = useState(false);
  return (
    <React.Fragment>
      <div className="tabview mb-3">
        <div className="card">
          <TabView renderActiveOnly={false} className="tabview" scrollable>
            <TabPanel header="A/P Invoice Main" rightIcon="fas fa-th-large">
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <Card>
                    <Card.Header>
                      <i className="fas fa-window-maximize"></i>
                      <span>
                        <strong>Account Payable Invoice Header</strong>
                      </span>
                      {values.incomingInvoiceCode !== "" ? (
                        <React.Fragment>
                          <Badge
                            className="float-right ml-1"
                            variant={
                              values.paymentStatus === 1
                                ? "danger"
                                : values.paymentStatus === 2
                                ? "warning"
                                : values.paymentStatus === 3
                                ? "success"
                                : null
                            }
                          >
                            {values.paymentStatus !== 0
                              ? "Payment " + values.paymentStatusDesc
                              : null}
                          </Badge>
                          <Badge
                            className="float-right ml-1"
                            variant={
                              values.grStatus === 1
                                ? "danger"
                                : values.grStatus === 2
                                ? "warning"
                                : values.grStatus === 3
                                ? "success"
                                : null
                            }
                          >
                            {values.grStatus !== 0
                              ? "Goods " + values.grStatusDesc
                              : null}
                          </Badge>
                          <Badge
                            className="float-right ml-1"
                            variant={
                              values.invoiceType === "1"
                                ? "primary"
                                : values.invoiceType === "2"
                                ? "info"
                                : null
                            }
                          >
                            {values.invoiceType === "1"
                              ? "Normal A/P Invoice"
                              : values.invoiceType === "2"
                              ? "Recurring A/P Invoice"
                              : null}
                          </Badge>
                        </React.Fragment>
                      ) : null}
                    </Card.Header>
                    <Card.Body>
                      <div className="row">
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          {values.incomingInvoiceCode !== "" ? (
                            <FormTextField
                              label="A/P Invoice ID"
                              name="incomingInvoiceCode"
                              readonly
                            />
                          ) : null}
                          <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-6">
                              <FormTextField
                                label="Document Reference"
                                name="docRefDesc"
                                searchButton={values.ID > 0 ? false : true}
                                clearButton={values.ID > 0 ? false : true}
                                readonly
                                onClearFields={() => {
                                  setFieldValue("docRef", "0");
                                  setFieldValue("docRefDesc", "");
                                  setFieldValue("purchaseOrderID", 0);
                                  setFieldValue("purchaseOrderCode", "");
                                  setFieldValue("invoiceType", "1");
                                  setFieldValue("vendorName", "");
                                  setFieldValue("vendorID", 0);
                                  setFieldValue(
                                    "currencyID",
                                    companyProfile.currency.ID
                                  );
                                  setFieldValue(
                                    "currencyCode",
                                    companyProfile.currency.currencyCode
                                  );
                                  setFieldValue("invoiceItem", []);
                                  setFieldValue("subTotal", 0);
                                  setFieldValue("discountPercent", 0);
                                  setFieldValue("discountAmount", 0);
                                  setFieldValue("taxPercent", 0);
                                  setFieldValue("taxAmount", 0);
                                  setFieldValue("taxName", "");
                                  setFieldValue("exchangeRate", 0);
                                  setFieldValue("grandTotal", 0);
                                  setFieldValue(
                                    "recStartDate",
                                    DateTime.now().startOf("day")
                                  );
                                  setFieldValue("recIssueDate", 1);
                                  setFieldValue("recDeadlineDate", 1);
                                  setFieldValue("recEvery", 1);
                                  setFieldValue("periodType", "M");
                                  setFieldValue("addressName", {});
                                  setFieldValue("address", "");
                                  setFieldValue("city", "");
                                  setFieldValue("province", "");
                                  setFieldValue(
                                    "countryCode",
                                    companyProfile.countryCode
                                  );
                                  setFieldValue("postalCode", "");
                                  setFieldValue("addressPhone", "");
                                  setFieldValue("addressEmail", "");
                                  setFieldValue("contact", {});
                                  setFieldValue("contactName", "");
                                  setFieldValue("position", "");
                                  setFieldValue("contactPhone", "");
                                  setFieldValue("contactEmail", "");
                                }}
                                onSearchClick={() => {
                                  setOpenSearchDocRef(true);
                                }}
                              />
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-6">
                              <FormTextField
                                label="Purchase Order ID"
                                name="purchaseOrderCode"
                                readonly
                              />
                            </div>
                          </div>
                          <FormTextField
                            label="Vendor Name"
                            name="vendorName"
                            searchButton={
                              values.purchaseOrderID > 0 ? false : true
                            }
                            readonly
                            onSearchClick={() => {
                              setOpenSearchVendor(true);
                            }}
                          />
                          <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-6">
                              <FormTextField
                                label="Currency"
                                name="currencyCode"
                                searchButton={
                                  values.purchaseOrderID > 0 ? false : true
                                }
                                readonly
                                onSearchClick={() => {
                                  setOpenSearchCurrency(true);
                                }}
                              />
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-6">
                              <FormTextField
                                label="Exchange Rate To Base Currency"
                                name="exchangeRate"
                                currencyField
                                fullDecimals={true}
                                readonly
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          {values.vendorID > 0 ? (
                            <FormTextField
                              label="Vendor Bank Account"
                              name="vendBankAccountDesc"
                              searchButton
                              clearButton
                              readonly
                              onSearchClick={() => {
                                setOpenSearchBankVendor(true);
                              }}
                              onClearFields={() => {
                                setFieldValue("vendBankAccountID", 0);
                                setFieldValue("vendBankAccountDesc", "");
                              }}
                            />
                          ) : (
                            <FormTextField
                              label="Vendor Bank Account"
                              name="vendBankAccountDesc"
                              readonly
                            />
                          )}
                          <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-6">
                              <FormDateField
                                label="Invoice Date"
                                name="invoiceDate"
                                readonly={values.ID > 0 ? true : false}
                              />
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-6">
                              <FormDateField
                                label="Deadline Date"
                                name="deadlineDate"
                              />
                            </div>
                          </div>
                          <FormTextField
                            label="Vendor Invoice Number"
                            name="vendorInvoiceNo"
                          />
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              </div>
            </TabPanel>
            <TabPanel
              header={`Address & Contact`}
              rightIcon="fas fa-map-marked-alt"
            >
              <div className="row">
                <div className="col-sm-6 col-md-6 col-lg-6 mb-3 mb-md-0">
                  <IncomingInvoiceAddress
                    values={values}
                    addressProp="address"
                    vendorAddresses={vendorAddresses}
                    title="Vendor"
                    setFieldValue={setFieldValue}
                    vendorAddressDefault={vendorAddressDefault}
                    handleVendorAddressDefault={handleVendorAddressDefault}
                  />
                </div>
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <IncomingInvoiceContact
                    values={values}
                    vendorContacts={vendorContacts}
                    title="Vendor"
                    setFieldValue={setFieldValue}
                    vendorContactDefault={vendorContactDefault}
                    handleVendorContactDefault={handleVendorContactDefault}
                  />
                </div>
              </div>
            </TabPanel>
            <TabPanel
              header={`Note, Terms & Conditions`}
              rightIcon="fas fa-sticky-note"
            >
              <div className="row mb-3">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <Card>
                    <Card.Header>
                      <i className="fas fa-sticky-note"></i>
                      <span>
                        <strong>Note</strong>
                      </span>
                    </Card.Header>
                    <Card.Body>
                      <Editor
                        style={{ height: "200px", width: "100%" }}
                        onTextChange={(e) => {
                          setFieldValue("note", e.htmlValue);
                        }}
                        value={values.note}
                        placeholder="Type your notes here..."
                      />
                    </Card.Body>
                  </Card>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <Card>
                    <Card.Header>
                      <i className="fas fa-sticky-note"></i>
                      <span>
                        <strong>Terms & Conditions</strong>
                      </span>
                    </Card.Header>
                    <Card.Body>
                      <Editor
                        style={{ height: "200px", width: "100%" }}
                        onTextChange={(e) => {
                          setFieldValue("toc", e.htmlValue);
                        }}
                        value={values.toc}
                        placeholder="Type your terms & conditions here..."
                      />
                    </Card.Body>
                  </Card>
                </div>
              </div>
            </TabPanel>
          </TabView>
        </div>
      </div>
      <DialogLayout
        open={openSearchCurrency}
        title="Search Currency"
        onCloseDialog={() => {
          setOpenSearchCurrency(false);
        }}
        maxWIdth="sm"
      >
        <SearchCurrency
          onSelectCurrency={(currency) => {
            setFieldValue("currencyID", currency.ID);
            setFieldValue("currencyCode", currency.currencyCode);
            setFieldValue("exchangeRate", currency.exRateToBaseCurr);
            setOpenSearchCurrency(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchCurrency(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>

      <DialogLayout
        open={openSearchDocRef}
        title="Search Document Reference"
        onCloseDialog={() => {
          setOpenSearchDocRef(false);
        }}
        minHeight={true}
      >
        <SearchIncomingInvoiceDocRef
          onSelectDocRef={(purchaseOrder) => {
            setFieldValue("docRefDesc", "Purchase Order");
            setFieldValue("docRef", "1");
            setFieldValue("purchaseOrderID", purchaseOrder.ID);
            setFieldValue("purchaseOrderCode", purchaseOrder.purchaseOrderCode);
            setFieldValue("vendorID", purchaseOrder.vendor.ID);
            setFieldValue("vendorName", purchaseOrder.vendor.vendorName);
            setFieldValue("currencyID", purchaseOrder.currency.ID);
            setFieldValue("currencyCode", purchaseOrder.currency.currencyCode);
            getPurchaseOrderItems(purchaseOrder.ID, "all").then((response) => {
              const { data } = response.data;
              const { poItems } = data;
              let invoiceItem = [];
              poItems.forEach((item, index) => {
                invoiceItem.push({
                  ID: 0,
                  itemType: item.item.itemType,
                  purchaseOrderItemID: item.ID,
                  itemID: item.itemID,
                  itemType: item.itemType,
                  itemTypeName: item.itemTypeName,
                  itemCode: item.itemCode,
                  itemName: item.itemName,
                  varCode: item.varCode,
                  qty: item.qtyLeft,
                  qtyLeft: item.qtyLeft,
                  uomID: item.uomID,
                  uomName: item.itemUom.uom,
                  unitPrice: item.unitPrice,
                  taxPercent: item.taxPercent,
                  taxAmount: item.taxAmount,
                  discountPercent: item.discountPercent,
                  discountAmount: item.discountAmount,
                  totalPrice: item.totalPrice,
                  expenseAccountID: 0,
                  accountName: "",
                  poItem: true,
                  unRegItem: false,
                  deleteInd: false,
                });
              });
              setFieldValue("invoiceItem", invoiceItem);
              calculateTotalPrice(
                purchaseOrder.discountPercent,
                purchaseOrder.taxPercent,
                invoiceItem,
                purchaseOrder.purchaseOrderAddCost
              );
            });
            /*
            setFieldValue("subTotal", purchaseOrder.subTotal);
            setFieldValue("discountPercent", purchaseOrder.discountPercent);
            setFieldValue("discountAmount", purchaseOrder.discountAmount);
            setFieldValue("taxPercent", purchaseOrder.taxPercent);
            setFieldValue("taxAmount", purchaseOrder.taxAmount);
            setFieldValue("grandTotal", purchaseOrder.grandTotal);
            */
            setFieldValue("exchangeRate", purchaseOrder.exchangeRate);
            setFieldValue("address", purchaseOrder.address);
            setFieldValue("city", purchaseOrder.city);
            setFieldValue("province", purchaseOrder.province);
            setFieldValue("countryCode", purchaseOrder.countryCode);
            setFieldValue("postalCode", purchaseOrder.postalCode);
            setFieldValue("addressPhone", purchaseOrder.addressPhone);
            setFieldValue("addressEmail", purchaseOrder.addressEmail);
            setFieldValue("contactName", purchaseOrder.vendor.contactName);
            setFieldValue("position", purchaseOrder.vendor.position);
            setFieldValue("contactPhone", purchaseOrder.vendor.contactPhone);
            setFieldValue("contactEmail", purchaseOrder.vendor.contactEmail);
            setVendorAddressDefault(true);
            setVendorContactDefault(true);
            changeVendor(purchaseOrder.vendorID);
            setOpenSearchDocRef(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchDocRef(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openSearchVendor}
        title="Search Vendor"
        onCloseDialog={() => {
          setOpenSearchVendor(false);
        }}
        maxWIdth="md"
      >
        <SearchVendor
          onSelectVendor={(vendor) => {
            setFieldValue("vendorID", vendor.ID);
            setFieldValue("vendorName", vendor.vendorName);
            setFieldValue("address", vendor.address);
            setFieldValue("city", vendor.city);
            setFieldValue("province", vendor.province);
            setFieldValue("countryCode", vendor.countryCode);
            setFieldValue("postalCode", vendor.postalCode);
            setFieldValue("addressPhone", vendor.addressPhone);
            setFieldValue("addressEmail", vendor.addressEmail);
            setFieldValue("contactName", vendor.contactName);
            setFieldValue("position", vendor.position);
            setFieldValue("contactPhone", vendor.contactPhone);
            setFieldValue("contactEmail", vendor.contactEmail);
            changeVendor(vendor.ID);
            setVendorAddressDefault(true);
            setVendorContactDefault(true);
            setOpenSearchVendor(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchVendor(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openSearchBankVendor}
        title="Search Vendor Bank Account"
        onCloseDialog={() => {
          setOpenSearchBankVendor(false);
        }}
        maxWIdth="lg"
      >
        {values.vendorID > 0 ? (
          <SearchVendorBankAccount
            vendorID={values.vendorID}
            onSelectBankAccount={(bank) => {
              setFieldValue("vendBankAccountID", bank.ID);
              setFieldValue(
                "vendBankAccountDesc",
                `${bank.accountNo} / ${bank.accountHolder} / ${bank.bankName} / ${bank.bankBranch} / ${bank.bankCode}`
              );
              setOpenSearchBankVendor(false);
            }}
          />
        ) : null}
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchBankVendor(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );
  function calculateTotalPrice(
    discountPercent = 0,
    taxPercent = 0,
    invoiceItem = [],
    poAddCost = []
  ) {
    const additionalCost = [];
    let subTotal = 0;
    let grandTotal = 0;
    let addCostTotal = 0;

    invoiceItem.forEach((item, index) => {
      subTotal += parseFloat(item.totalPrice);
    });

    poAddCost.forEach((item, index) => {
      addCostTotal += parseFloat(item.costPrice);
      additionalCost.push({
        poAddCostID: item.ID,
        costComponentID: item.costComponentID,
        itemName: item.itemName,
        costPrice: item.costPrice,
        expenseAccountID: item.expenseAccountID,
        accountName: item.accountName,
        deleteInd: false,
      });
    });

    const discountAmount = amountByPercent(discountPercent, subTotal);
    const taxAmount = amountByPercent(taxPercent, subTotal - discountAmount);
    grandTotal = subTotal - discountAmount + taxAmount;
    grandTotal += addCostTotal;
    setFieldValue(`additionalCost`, additionalCost);
    setFieldValue(`addCostTotal`, addCostTotal);
    setFieldValue(`subTotal`, subTotal);
    setFieldValue(`taxPercent`, taxPercent);
    setFieldValue(`taxAmount`, taxAmount);
    setFieldValue(`discountPercent`, discountPercent);
    setFieldValue(`discountAmount`, discountAmount);
    setFieldValue("grandTotal", grandTotal);
  }

  async function changeVendor(vendorID) {
    const responseAddress = await getVendorAddress(vendorID);
    const { data: dataAddress } = responseAddress.data;

    const responseContact = await getVendorContact(vendorID);
    const { data: dataContact } = responseContact.data;

    setVendorAddresses(dataAddress.addresses);
    setVendorContacts(dataContact.contacts);
  }

  function handleVendorAddressDefault() {
    setVendorAddressDefault(false);
  }

  function handleVendorContactDefault() {
    setVendorContactDefault(false);
  }
}

export default IncomingInvoiceHeader;
